import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CoreMaterialModule } from '@nttp/core-material';
import { DialogSetTimeoutComponent } from './dialog-set-timeout/dialog-set-timeout.component';
import { EmailConfirmationErrorComponent } from './email-confirmation-error/email-confirmation-error.component';
import { CommonDialogComponent } from '@pg-app/common/common-dialog/common-dialog.component';
import { ConfirmDownloadPdfExcelComponent } from '@pg-app/common/confirm-download-pdf-excel/confirm-download-pdf-excel.component';
import { ReactiveFormsModule } from '@angular/forms';
import { SwiftCharacterSetComponent } from './swift-character-set/swift-character-set';
import { CoreUiModule } from '@nttp/core-ui';

@NgModule({
  imports: [CommonModule, CoreMaterialModule, ReactiveFormsModule, CoreUiModule],
  declarations: [CommonDialogComponent, DialogSetTimeoutComponent, ConfirmDownloadPdfExcelComponent, EmailConfirmationErrorComponent, SwiftCharacterSetComponent],
  entryComponents: [CommonDialogComponent, ConfirmDownloadPdfExcelComponent, DialogSetTimeoutComponent, SwiftCharacterSetComponent]
})
export class CommonDialogModule { }
